import { AppInjector } from './../../app-injector';
import { ApiUrl } from './../api-url.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceProvider } from '../service.provider';
import Wardrobe from "../../models/Wardrobe";
import {catchError, map} from "rxjs/operators";
import {Observable} from "rxjs/Observable";
import * as _ from 'lodash';
import ArrayList from "../../models/ArrayList";
import Category from "../../models/Category";

@Injectable()
export class WardrobeService extends ServiceProvider {

  protected url = '/api/v1/wardrobes';

  constructor(
  ) {
    super(
      AppInjector.get(HttpClient),
      AppInjector.get(ApiUrl),
      'Wardrobe'
    );
  }

  allWithExtras(): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '?page=1&per_page=500').pipe(
      map(result => {
        return _.map((result as any).data, item => new Wardrobe(item));
      }),
      catchError(error => {
        throw error;
      })
    );
  }

  getAllNestedWardrobe(): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '/paths').pipe(
      map(result => {
        return new ArrayList<Wardrobe>(Wardrobe, (result as any).data);
      }),
      catchError(error => {
        throw error;
      })
    );
  }
}
